import * as actionTypes from './actionTypes';

export const updateUserState = (payload) => ({
  type: actionTypes.UPDATE_USER_STATE,
  payload,
});

export const performLoginAction = (params) => ({
  type: actionTypes.LOGIN,
  params,
});

export const performLogoutAction = (payload) => ({
  type: actionTypes.LOGOUT,
  payload,
});

// export const performRefreshTokenAction = () => ({
//   type: actionTypes.REFRESH_TOKEN,
// });

export const handleSSOLoginAction = (payload) => ({
  type: actionTypes.HANDLE_SSO_LOGIN,
  payload
});

export const setActiveMenu = (payload) => ({
  type: actionTypes.SET_ACTIVE_MENU,
  payload
});

export const setShowLogoutAlert = (payload) => ({
  type: actionTypes.SET_SHOW_LOGOUT_ALERT,
  payload
});

export const clearCookiesAndSessionsAction = () => ({
  type: actionTypes.CLEAR_COOKIES_AND_SESSIONS,
});

export const setShowNotFoundPage = (payload) => ({
  type: actionTypes.SET_SHOW_NOT_FOUND_PAGE,
  payload
});

export const fetchMicrosoftUsers = () => ({
  type: actionTypes.FETCH_MICROSOFT_USERS,
});

